import React, { useEffect } from "react";
import { TawkChat } from "@/components";

const CompatibilityAffinitiesScreen: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="v2-body">
      <TawkChat />

      <div className="v2-hero">
        <img
          src={process.env.REACT_APP_URL_COMPATIBILITY_AFFINITIES_BANNER}
          className="v2-hero-bg"
          alt="Mimo Cupido Casal"
          loading="eager"
        />
        <div className="v2-container">
          <div className="v2-hero-content">
            <h1>
              Compatibilidade e Afinidades <br />
              <span className="v2-gold-text">
                A Base dos Relacionamentos Duradouros
              </span>
            </h1>
          </div>
        </div>
      </div>

      <section className="v2-section">
        <p>
          Pessoas bem-sucedidas sabem o que querem da vida – e nos
          relacionamentos não seria diferente. O verdadeiro luxo não está apenas
          no status, mas na paz de espírito de estar ao lado de alguém com quem
          você compartilha valores, intelecto e visão de mundo.
        </p>
      </section>

      <section className="v2-section">
        <h2>Muito Além do Convencional: Encontros Baseados em Valores</h2>
        <p>
          A atração inicial abre portas, mas são as afinidades que constroem uma
          história. O algoritmo e a curadoria do Mimo Cupido são desenhados para
          ir além da superficialidade. Conectamos indivíduos que apreciam:
          Diálogos Enriquecedores: A atração intelectual é o pilar das relações
          modernas mais bem-sucedidas. Momentos de Qualidade: Parceiros que
          compreendem a rotina de quem lidera negócios e empresas, valorizando o
          tempo de qualidade juntos. Estilo de Vida Compartilhado: A harmonia
          perfeita entre quem já alcançou o sucesso e quem admira e complementa
          essa jornada.
        </p>
      </section>

      <section className="v2-section">
        <h2>Como a Exclusividade Transforma sua Experiência</h2>
        <p>
          Navegar no mundo dos encontros pode ser exaustivo. É por isso que
          filtramos o ruído.
        </p>
      </section>

      <section className="v2-section">
        <h2>Um Círculo Restrito de Pessoas Excepcionais</h2>
        <p>
          Ao focar na compatibilidade profunda, criamos uma comunidade seleta.
          Homens e mulheres de sucesso encontram aqui um espaço onde não
          precisam esconder suas conquistas, mas sim celebrá-las com alguém que
          entende e acompanha seu ritmo de vida.
        </p>
      </section>
    </div>
  );
};

export default CompatibilityAffinitiesScreen;
